import cn from 'classnames';
import styles from './M_CapsuleCommentMobilePreview.module.css';
import { useTranslation } from '@/hooks/useTranslation';

interface M_CapsuleCommentMobilePreviewProps {
  text: string;
  onExpand?: () => void;
}

export default function M_CapsuleCommentMobilePreview({
  text,
  onExpand,
}: M_CapsuleCommentMobilePreviewProps) {
  const t = useTranslation();
  const previewText =
    text && text.trim().length > 0 ? text : t('capsuleReactions.noCommentYet');

  return (
    <div className={styles.wrapper}>
      <pre className={cn(styles.text, 'text-p-7')}>{previewText}</pre>
      {onExpand && (
        <button
          type='button'
          className={cn(styles.expand_button, 'text-p-4')}
          onClick={onExpand}
        >
          {t('capsulePost.expand')}
        </button>
      )}
    </div>
  );
}
